document.onreadystatechange = function() {
  const loader = document.getElementById('loader-wrapper');
  const siteContainer = document.querySelector('.site-container');

  if (document.readyState !== "complete") {
      if (loader) loader.style.display = 'flex';
      if (siteContainer) siteContainer.classList.add('site-container--hidden');
  } else {
      if (loader) loader.style.display = 'none';
      if (siteContainer) siteContainer.classList.remove('site-container--hidden');
  }
};
